import { get, post, put, deleted } from '..';
import routes from './routes';

const CustomerServices = {
  getCustomerOrders: async (params) => {
    const data = await get(routes.getCustomerOrders, params);
    return data;
  },
  getOrderReportByCustomer: async (id) => {
    const data = await get(routes.getOrderReportByCustomer + id + '/orders');
    return data;
  },
}

export default CustomerServices